import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Parametro, Notificacion, DetalleFolio } from 'app/models/parametro.model';
import { Plantilla, PlantillaHtml } from 'app/models/plantilla.model';
import { Empresa, PagareCSV } from 'app/models/pagare.model';
import { EstadoPagare } from 'app/models/pagare.model';

@Injectable({
    providedIn: 'root',
})
export class ParametrosService {
    readonly APIurl = environment.apis + '/parametro';
    constructor(private http: HttpClient) { }

    //#region CORREOS
    listarCorreosEventos() {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<Parametro[]>(this.APIurl + '/correos', options);
    }

    getCorreo(correo: string) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<any>(this.APIurl + '/correo/' + correo, options);
    }

    postCorreo(infoCorreo: any) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };

        let payload = infoCorreo;

        return this.http.post(this.APIurl + '/correo', payload, options);
    }
    //#endregion
    //#region  estados
    getEstadosPagare() {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<EstadoPagare[]>(this.APIurl + '/estado_pagare', options);
    }
    updateEstadosPagare(estadosPagare: any) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        let payload = estadosPagare;
        return this.http.post<EstadoPagare[]>(this.APIurl + '/actualiza_pagare', payload, options);
    }
    // creaActualizaRol(id: string, nombre: string, permissions: Permission[]) {
    //     const headers = new HttpHeaders({
    //         'content-type': 'application/json; charset=utf-8'
    //     });
    //     let options = { headers: headers };
    //     let payload = {
    //         id: id,
    //         name: nombre,
    //         permissions: permissions
    //     }
    //     return this.http.post(this.APIurl + "/rol", payload, options);
    // }
    //#endregion
    //#region NOTIFICACIONES
    getNotificaciones() {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<Notificacion[]>(this.APIurl + '/notificaciones', options);
    }

    updateMailNotificaciones(notificaciones: any) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        let payload = notificaciones;
        return this.http.post<Notificacion[]>(this.APIurl + '/actualiza_notificaciones', payload, options);
    }

    //#endregion
    //#region PLANTILLAS
    listarPlantillas() {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<Plantilla[]>(this.APIurl + '/plantillas', options);
    }

    getPlantilla(plantilla: string) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<any>(this.APIurl + '/plantilla/?plantilla=' + plantilla, options);
    }

    postPlantilla(infoPlantilla: any) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };

        let payload = infoPlantilla;

        return this.http.post(this.APIurl + '/plantilla', payload, options);
    }

    getPagareFormulario24() {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<any>(this.APIurl + '/pagareFormulario24', options);
    }

    postPagareFormulario24(infoPagareFormulario24: any) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };

        let payload = infoPagareFormulario24;

        return this.http.post(this.APIurl + '/pagareFormulario24', payload, options);
    }
    //#endregion
    //#region Folio
    getFolio() {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<any[]>(this.APIurl + '/folio', options);
    }

    getDetalleFolio(ID: string) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let options = { headers: headers };
        return this.http.get<DetalleFolio[]>(this.APIurl + '/detalle_folios/' + ID, options);
    }
    createNewRangoFolio(infoFolio: any) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8',
        });
        let payload = infoFolio;
        let options = { headers: headers };
        return this.http.post(this.APIurl + '/nuevo_folio/', payload, options);
    }
    deleteRangoFolio(infoFolio: any) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8'
        });
        let payload = {
            folio: infoFolio
        }

        let options = { headers: headers, body: payload };
        return this.http.delete(this.APIurl + '/delete_folio/', options);
    }
    eliminaUsuarios(userIds: string[]) {
        const headers = new HttpHeaders({
            'content-type': 'application/json; charset=utf-8'
        });
        let payload = {
            userIds: userIds
        }

        let options = { headers: headers, body: payload };

        return this.http.delete<any>(this.APIurl + "/usuarios", options);
    }

    //#endregion
    // companyInfo() {
    //     const headers = new HttpHeaders({
    //         'content-type': 'application/json; charset=utf-8',
    //     });
    //     let options = { headers: headers };
    //     return this.http.get<Empresa>(this.APIurl + '/empresa', options);
    // }
}
